import { useEffect, useState } from "react";

/**
 * Match a CSS media query from React. Returns false during SSR and on the first
 * client render, then settles — so components that branch on it never produce a
 * hydration mismatch, they just upgrade a frame later.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Tailwind's `lg` breakpoint — where the map gains a persistent sidebar. */
export const LG_QUERY = "(min-width: 1024px)";
